module.exports = __webpack_public_path__ + "img/white_paper3.523faf31.png";